"use client";

import { useState } from "react";
import Link from "next/link";
import { trackEvent } from "@/lib/analytics";

export function ReferralLinkBox({
  referralCode,
  isLoggedIn,
}: {
  referralCode: string | null;
  isLoggedIn: boolean;
}) {
  const [copied, setCopied] = useState(false);
  const referralLink = referralCode ? `peakwave.co/ref/${referralCode}` : "";
  const fullLink = referralCode
    ? `https://peakwave.co/ref/${referralCode}`
    : "";

  function copyLink() {
    if (!referralCode) return;
    navigator.clipboard.writeText(fullLink);
    trackEvent("referral_link_copied");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  if (isLoggedIn && referralCode) {
    return (
      <>
        <div className="flex gap-2">
          <input
            type="text"
            readOnly
            value={referralLink}
            className="flex-1 min-w-0 px-4 py-3 border border-border-light rounded-sm text-[14px] font-mono bg-warm-bg text-charcoal outline-none"
          />
          <button
            onClick={copyLink}
            className={`px-5 py-3 rounded-sm text-[14px] font-semibold border-none cursor-pointer font-sans transition-all whitespace-nowrap min-h-[44px] ${
              copied
                ? "bg-success text-white"
                : "bg-gold text-navy hover:bg-gold-light"
            }`}
          >
            {copied ? "Copied!" : "Copy link"}
          </button>
        </div>
        <p className="text-text-muted text-[12px] mt-2">
          Or share your code:{" "}
          <span className="font-semibold text-navy">{referralCode}</span>
        </p>
      </>
    );
  }

  if (isLoggedIn) {
    return (
      <p className="text-text-muted text-[13px]">
        Your referral code is being generated. Refresh the page in a moment.
      </p>
    );
  }

  return (
    <Link
      href="/login"
      className="bg-gold text-navy px-6 py-3.5 rounded-sm text-[15px] font-semibold no-underline font-sans transition-all hover:bg-gold-light inline-flex items-center gap-2 min-h-[44px]"
    >
      Log in to get your personal referral link &rarr;
    </Link>
  );
}
